<template>
    <div class="content-box">
      <div class="content-header">
        <el-input v-model="queryForm.deviceCode" placeholder="请输入设备编号" class="input"></el-input>
        <el-input v-model="queryForm.phoneOrNickname" placeholder="请输入用户手机号或昵称" class="input"></el-input>

        <el-button type="plain" class="cotent-btn" @click="handleSearch">搜索</el-button>
      </div>
      <div class="table-list">
        <ETable :columns="columns" :data="tableData" style="width: 100%" :max-height="tableMaxheight" :header-cell-style="headerCellStyle" :cell-style="cellStyle" border
            v-loading="loading">
            <template #nickname="{row}">
              <div class="_flex user-info__box" v-if="row.nickname">
                <el-avatar shape="circle" :size="50" fit="content" :src="row.icon"></el-avatar>
                <div class="_flex user-info__box--basic">
                  <span>{{row.nickname}}</span>
                  <span>{{row.phone}}</span>
                </div>
              </div>
            </template>
            <template #bindingStatus="{row}">
              <span>{{ row.bindingStatus === 1 ? '已绑定' : '未绑定' }}</span>
            </template>
            <template #action="{row}">
              <el-button type="text" v-if="row.userId" @click="unBind(row)">解绑</el-button>
              <el-button type="text" @click="viewBindRecord(row)">绑定记录</el-button>
            </template>
        </ETable>
        <!-- 分页 -->
        <el-pagination style="margin-top: 20px" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="itemTotal"></el-pagination>
      </div>
      <el-dialog title="绑定记录" :visible.sync="dialogVisible" width="700px" :before-close="dialogClose" :close-on-click-modal="false">
          <div class="edit-box">
            <el-table :data="bindRecordList" border max-height="500">
              <el-table-column label="操作时间" prop="createdTime">
              </el-table-column>
              <el-table-column label="操作" prop="action">
                <template #default="{row}">
                  <div class="_flex">
                    <div :class="row.bindingStatus == 1 ? 'disable-btn' : 'enable-btn'">
                      {{row.bindingStatus == 1 ? '绑定' : '解绑'}}
                    </div>
                    <div class="_flex user-info__box" v-if="row.bindingStatus == 1">
                      <el-avatar shape="circle" :size="50" fit="content" :src="row.icon"></el-avatar>
                      <div class="_flex user-info__box--basic">
                        <span>{{row.nickname}}</span>
                        <span>{{row.phone}}</span>
                      </div>
                    </div>
                  </div>

                </template>
              </el-table-column>
            </el-table>
            <!-- 绑定记录分页 -->
            <el-pagination style="margin-top: 20px" background @size-change="handleBindSizeChange"
              @current-change="handleBindCurrentChange" :current-page="bindCurrentPage" :page-sizes="[10, 20, 50]" :page-size="bindPageSize"
              layout="total, sizes, prev, pager, next" :total="bindTotal"></el-pagination>
          </div>
        </el-dialog>
    </div>
  </template>

  <script>
  import { Watch, Mixins, Component } from "vue-property-decorator";
  import tablePagination from "@/mixins/tablePagination";
  import loading from "@/mixins/loading";
  import Resize from "@/mixins/resize";

  import { sleepMonitorList, unBind, bindingRecords } from "@/api/sleep"

  // 常量
  import { ServiceStatusEnum } from "@/enum/service.enum";

  import ETable from "@/components/ETable.vue";

  @Component({
    components: { ETable }
  })
  export default class SleepMonitor extends Mixins(loading, tablePagination, Resize) {
    serviceStatusEnum = ServiceStatusEnum

    queryForm = { // 查询参数
        deviceCode: "",
        phoneOrNickname: "",
    }

    tableData = [];
    itemTotal = 0;

    dialogVisible = false;
    dialogTitle = "";
    
    columns = [
        { label: "设备编号", prop: "deviceCode" },
        { label: "设备名称", prop: "deviceName" },
        { label: "当前绑定用户", prop: "nickname" },
        { label: "最后绑定时间", prop: "lastBindingTime" },
        { label: "最后数据上传时间", prop: "lastUploadTime" },
        { label: "操作", prop: "action", width: "200" },
    ]
    
    bindRecordList = [];
    bindTotal = 0;
    bindCurrentPage = 1;
    bindPageSize = 10;
    currentDeviceCode = "";


    mounted() {
      this.windowResize(310)
      this.getData();
    }
    getData() {
      this.showLoading();
      const { deviceCode, phoneOrNickname } = this.queryForm;
      sleepMonitorList({
        deviceCode,
        phoneOrNickname,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }).then(res => {
        this.hideLoading();
        this.tableData = res.data?.list || [];
        this.itemTotal = res.data?.total || 0;
      }).finally(() => {
        this.hideLoading();
      });
    }

    //重置分页参数
    resetPages() {
      this.currentPage = 1;
    }

    // 搜索
    handleSearch() {
      this.resetPages();
      this.getData();
    }

    async viewBindRecord(row) {
      this.dialogVisible = true;
      this.currentDeviceCode = row.deviceCode;
      this.bindCurrentPage = 1;
      await this.getBindRecordList();
    }

    getBindRecordList() {
      return bindingRecords({
        deviceCode: this.currentDeviceCode,
        pageNum: this.bindCurrentPage,
        pageSize: this.bindPageSize,
      }).then(res => {
        this.bindRecordList = res.data?.list || [];
        this.bindTotal = res.data?.total || 0;
      });
    }

    handleBindSizeChange(size) {
      this.bindPageSize = size;
      this.bindCurrentPage = 1;
      this.getBindRecordList();
    }
    
    handleBindCurrentChange(page) {
      this.bindCurrentPage = page;
      this.getBindRecordList();
    }

    unBind(row) {
      this.$confirm(`是否确定解绑?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
      }).then((() => {
        this.unBindAction(row)
      }))
    }

    unBindAction(row) {
      const { deviceCode } = row;
      unBind({ deviceCode }).then((res) => {
        this.handleSearch();
      })
    }

    dialogClose() {
      this.dialogVisible = false;
      this.bindRecordList = [];
      this.bindTotal = 0;
      this.bindCurrentPage = 1;
    }

  }
  </script>



  <style lang="scss" scoped>
  @import "@/styles/app";

.content-box {
  background: #edf0f9;
}

.content-header {
  height: 80px;
  background: #ffffff;
  border-bottom: 1px solid #dfe2e4;
  border-left: 1px solid #dfe2e4;
  border-right: 1px solid #dfe2e4;
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.input {
  width: 240px;
  height: 40px;
  background: #ffffff;
  border-radius: 2px;
  margin-left: 12px;
}
.cotent-btn {
  margin-left: 12px;
  border: 1px solid #0054ff;
}

.cotent-btn-big {
  margin-left: 40px;
  width: 300px;
  border: 1px dashed #0054ff;
}

.table-list {
  margin-top: 20px;
  background: #ffffff;
  border-radius: 8px;
  padding: 40px 40px;
  overflow: hidden;
  box-sizing: border-box;
  min-height: calc(100% - 101px);
}
.user-info__box{
  display: flex;
  margin-left: 10px;
  &--basic{
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    text-align: left;
    flex: 1;
    &>span{
      width: 100%;
    }
  }
}
  </style>
